import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import notify, { notificar } from '../utils/notify';
import '../styles/fechamentoernedu.css';
import '../styles/fmp.css';

const EnvioNotas_cliente = () => {
  const { cliente_id } = useParams();
  const navigate = useNavigate();

  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState({ tipo: '', texto: '' });
  useEffect(() => {
    if (!mensagem.texto) return;
    if (mensagem.tipo === 'success') notify.sucesso(mensagem.texto);
    else if (mensagem.tipo === 'warning') notify.aviso(mensagem.texto);
    else if (mensagem.tipo === 'danger') notify.erro(mensagem.texto);
    else notificar(mensagem.texto);
  }, [mensagem]);

  const [dadosCliente, setDadosCliente] = useState(null);
  const [abaAtiva, setAbaAtiva] = useState('envio');
  const [historico, setHistorico] = useState([]);
  const [carregandoHistorico, setCarregandoHistorico] = useState(false);

  // Prévia do e-mail + confirmação antes de enviar
  const [mostrarConfirmacao, setMostrarConfirmacao] = useState(false);
  const [carregandoPreview, setCarregandoPreview] = useState(false);
  const [previewHtml, setPreviewHtml] = useState('');
  const [previewAssunto, setPreviewAssunto] = useState('');
  const [previewDest, setPreviewDest] = useState('');
  const [confirmacaoMarcada, setConfirmacaoMarcada] = useState(false);

  const [formData, setFormData] = useState({
    mes_referencia: '',
    link_pasta_drive: '',
    pendencias: ''
  });

  useEffect(() => {
    carregarDadosCliente();
  }, []);

  useEffect(() => {
    if (abaAtiva === 'historico' && dadosCliente) {
      carregarHistorico();
    }
  }, [abaAtiva, dadosCliente]);

  const mostrarMensagem = (tipo, texto) => {
    setMensagem({ tipo, texto });
    setTimeout(() => setMensagem({ tipo: '', texto: '' }), 8000);
  };

  const carregarDadosCliente = async () => {
    try {
      const token = localStorage.getItem('access');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/clientes-bpo/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (response.data.success) {
        const cliente = response.data.dados.find(c => c.id === parseInt(cliente_id));
        if (cliente) setDadosCliente(cliente);
      }
    } catch (error) {
      console.error('Erro ao carregar dados do cliente:', error);
    }
  };

  const carregarHistorico = async () => {
    if (!dadosCliente) return;
    setCarregandoHistorico(true);
    try {
      const token = localStorage.getItem('access');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/historico-notas-cliente/`,
        { params: { cliente_id: cliente_id }, headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (response.data.success) setHistorico(response.data.dados);
    } catch (error) {
      console.error('Erro ao carregar histórico:', error);
      mostrarMensagem('danger', 'Erro ao carregar histórico de envios');
    } finally {
      setCarregandoHistorico(false);
    }
  };

  // Destinatário das notas: e-mail do FISCAL cadastrado no cliente;
  // se não houver, cai no e-mail da contabilidade (compatibilidade)
  const emailDestino = dadosCliente?.email_fiscal || dadosCliente?.email_contabilidade || '';
  const destinoEhFiscal = Boolean(dadosCliente?.email_fiscal);

  const validarFormulario = () => {
    if (!formData.mes_referencia) {
      mostrarMensagem('warning', 'Selecione o mês de referência');
      return false;
    }
    if (!formData.link_pasta_drive) {
      mostrarMensagem('warning', 'Informe o link da pasta do Google Drive');
      return false;
    }
    if (!formData.link_pasta_drive.includes('drive.google.com')) {
      mostrarMensagem('warning', 'O link informado não parece ser do Google Drive');
      return false;
    }
    if (!emailDestino) {
      mostrarMensagem('danger', 'Nenhum destinatário cadastrado: informe o Email Fiscal (ou o Email da Contabilidade) no cadastro do cliente.');
      return false;
    }
    return true;
  };

  const abrirPreview = async () => {
    if (!validarFormulario()) return;
    setPreviewHtml('');
    setPreviewAssunto('');
    setPreviewDest('');
    setConfirmacaoMarcada(false);
    setMostrarConfirmacao(true);
    setCarregandoPreview(true);
    try {
      const token = localStorage.getItem('access');
      const payload = {
        cliente_id: cliente_id,
        email_contabilidade: emailDestino,
        mes_referencia: formData.mes_referencia,
        link_pasta_drive: formData.link_pasta_drive,
        pendencias: formData.pendencias,
        preview: true
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/enviar-notas-fiscais-cliente/`,
        payload,
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }, timeout: 60000 }
      );
      if (response.data.success) {
        setPreviewHtml(response.data.html || '');
        setPreviewAssunto(response.data.assunto || '');
        setPreviewDest((response.data.destinatarios || []).join(', '));
      } else {
        mostrarMensagem('danger', response.data.mensagem || response.data.error || 'Erro ao gerar prévia');
        setMostrarConfirmacao(false);
      }
    } catch (error) {
      console.error('Erro ao gerar prévia:', error);
      mostrarMensagem('danger', 'Erro ao gerar a prévia do email');
      setMostrarConfirmacao(false);
    } finally {
      setCarregandoPreview(false);
    }
  };

  const enviarNotas = async () => {
    setMostrarConfirmacao(false);
    setCarregando(true);
    try {
      const token = localStorage.getItem('access');
      const payload = {
        cliente_id: cliente_id,
        email_contabilidade: emailDestino,
        mes_referencia: formData.mes_referencia,
        link_pasta_drive: formData.link_pasta_drive,
        pendencias: formData.pendencias
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/enviar-notas-fiscais-cliente/`,
        payload,
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
      if (response.data.success) {
        mostrarMensagem('success', response.data.mensagem || 'Notas fiscais enviadas com sucesso para a contabilidade!');
        setFormData({ mes_referencia: '', link_pasta_drive: '', pendencias: '' });
        if (abaAtiva === 'historico') carregarHistorico();
      } else {
        mostrarMensagem('danger', response.data.mensagem || response.data.error || 'Erro ao enviar notas fiscais');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.mensagem || error.response?.data?.error || error.message || 'Erro ao enviar notas fiscais';
      mostrarMensagem('danger', errorMsg);
    } finally {
      setCarregando(false);
    }
  };

  const gerarOpcoesMeses = () => {
    const meses = [];
    const hoje = new Date();
    for (let i = 0; i < 12; i++) {
      const data = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
      const valor = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
      const label = data.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
      meses.push({ valor, label: label.charAt(0).toUpperCase() + label.slice(1) });
    }
    return meses;
  };

  const formatarMesReferencia = (mesRef) => {
    if (!mesRef) return '-';
    const [ano, mes] = mesRef.split('-');
    const meses = {
      '01': 'Janeiro', '02': 'Fevereiro', '03': 'Março', '04': 'Abril',
      '05': 'Maio', '06': 'Junho', '07': 'Julho', '08': 'Agosto',
      '09': 'Setembro', '10': 'Outubro', '11': 'Novembro', '12': 'Dezembro'
    };
    return `${meses[mes] || mes}/${ano}`;
  };

  const renderAbaEnvio = () => (
    <div className="row g-4">
      <div className="col-md-6">
        <label className="form-label fw-bold">
          <i className="fas fa-calendar-alt me-2 text-primary"></i>
          Mês de Referência *
        </label>
        <select
          className="form-select form-select-lg"
          value={formData.mes_referencia}
          onChange={(e) => setFormData({ ...formData, mes_referencia: e.target.value })}
        >
          <option value="">Selecione o mês...</option>
          {gerarOpcoesMeses().map(mes => (
            <option key={mes.valor} value={mes.valor}>{mes.label}</option>
          ))}
        </select>
      </div>

      <div className="col-md-6">
        <label className="form-label fw-bold">
          <i className="fab fa-google-drive me-2" style={{ color: '#00205b' }}></i>
          Pasta do Drive com as Notas Fiscais *
        </label>
        <input
          type="url"
          className="form-control form-control-lg"
          value={formData.link_pasta_drive}
          onChange={(e) => setFormData({ ...formData, link_pasta_drive: e.target.value })}
          placeholder="https://drive.google.com/drive/folders/..."
        />
        <small className="text-muted">Cole aqui o link da pasta do Google Drive com as notas de retenção do mês.</small>
      </div>

      <div className="col-12">
        <label className="form-label fw-bold">
          <i className="fas fa-comment-dots me-2" style={{ color: '#00205b' }}></i>
          Observações
        </label>
        <textarea
          className="form-control posicao-obs-textarea"
          rows={4}
          value={formData.pendencias}
          onChange={(e) => setFormData({ ...formData, pendencias: e.target.value })}
          placeholder="Descreva aqui qualquer observação importante para a contabilidade..."
        ></textarea>
        <small className="text-muted">Este campo será incluído no email enviado para a contabilidade.</small>
      </div>

      {formData.mes_referencia && formData.link_pasta_drive && (
        <div className="col-12">
          <div className="card border-primary">
            <div className="card-header bg-primary text-white">
              <i className="fas fa-paper-plane me-2"></i>
              Resumo do Envio
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <p className="mb-2">
                    <strong>Mês:</strong> {gerarOpcoesMeses().find(m => m.valor === formData.mes_referencia)?.label}
                  </p>
                  <p className="mb-0">
                    <strong>Destinatário{destinoEhFiscal ? ' (fiscal)' : ''}:</strong> {emailDestino || 'Não cadastrado'}
                  </p>
                </div>
                <div className="col-md-6">
                  <p className="mb-0">
                    <strong>Observações:</strong> {formData.pendencias ? 'Sim' : 'Não informadas'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="col-12">
        <hr />
        <div className="d-flex justify-content-end gap-2">
          <button
            type="button"
            className="btn btn-outline-secondary btn-lg"
            onClick={() => setFormData({ mes_referencia: '', link_pasta_drive: '', pendencias: '' })}
            disabled={carregando}
          >
            <i className="fas fa-eraser me-2"></i>
            Limpar
          </button>
          <button
            type="button"
            className="btn-enviar-playful"
            onClick={abrirPreview}
            disabled={carregando || carregandoPreview || !dadosCliente}
          >
            <span>
              {(carregando || carregandoPreview) ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  {carregandoPreview ? 'Gerando prévia...' : 'Enviando...'}
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane"></i>
                  Enviar para Contabilidade
                </>
              )}
            </span>
          </button>
        </div>
      </div>
    </div>
  );

  const renderAbaHistorico = () => (
    <div>
      {carregandoHistorico ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
          <p className="mt-3 text-muted">Carregando histórico...</p>
        </div>
      ) : historico.length === 0 ? (
        <div className="text-center py-5">
          <i className="fas fa-inbox fa-4x text-muted mb-3"></i>
          <h5 className="text-muted">Nenhum envio realizado</h5>
          <p className="text-muted">Os envios de notas fiscais aparecerão aqui.</p>
          <button className="btn btn-primary mt-2" onClick={() => setAbaAtiva('envio')}>
            <i className="fas fa-plus me-2"></i>
            Fazer Primeiro Envio
          </button>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th style={{ width: '150px' }}>Mês Referência</th>
                <th style={{ width: '190px' }}>Data Envio</th>
                <th>Enviado para</th>
                <th>Observações</th>
                <th style={{ width: '90px' }}>Pasta</th>
              </tr>
            </thead>
            <tbody>
              {historico.map((item) => (
                <tr key={item.id}>
                  <td>
                    <span className="badge bg-primary fs-6">{formatarMesReferencia(item.mes_referencia)}</span>
                  </td>
                  <td>
                    <small className="text-muted">
                      <i className="fas fa-clock me-1"></i>{item.data_envio}
                    </small>
                  </td>
                  <td><small>{item.email_enviado_para}</small></td>
                  <td><small className="text-muted">{item.pendencias || '—'}</small></td>
                  <td>
                    {item.link_pasta_drive && (
                      <a
                        href={item.link_pasta_drive}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-outline-warning"
                        title="Abrir pasta no Drive"
                      >
                        <i className="fab fa-google-drive"></i>
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  return (
    <div className="container-fluid mt-4 fmp-brand-page">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center mb-2">
                    <i className="fas fa-file-invoice-dollar header-icon me-3"></i>
                    <h2 className="titulo-pagina m-0">Envio de Notas Fiscais</h2>
                  </div>
                  <p className="mb-1 opacity-75">
                    <i className="fas fa-file-upload me-2"></i>
                    {dadosCliente ? dadosCliente.nome : 'Carregando...'}
                  </p>
                </div>

                <div className="d-flex gap-2">
                  {emailDestino && (
                    <span className="badge bg-success me-2" title={destinoEhFiscal ? 'E-mail fiscal cadastrado' : 'Sem e-mail fiscal — usando o da contabilidade'}>
                      <i className="fas fa-envelope me-1"></i>
                      {destinoEhFiscal ? 'Fiscal: ' : ''}{emailDestino}
                    </span>
                  )}
                  <button
                    className="btn btn-light"
                    onClick={() => navigate(
                      dadosCliente?.sistema?.toLowerCase() === 'conta_azul'
                        ? `/dashboard-conta-azul/${cliente_id}`
                        : `/dashboard-cliente/${cliente_id}`
                    )}
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    Voltar ao Dashboard
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Abas */}
      <div className="row mb-4">
        <div className="col-12">
          <ul className="nav nav-tabs nav-fill">
            <li className="nav-item">
              <button
                className={`nav-link ${abaAtiva === 'envio' ? 'active' : ''}`}
                onClick={() => setAbaAtiva('envio')}
                style={{
                  backgroundColor: abaAtiva === 'envio' ? '#00205b' : 'transparent',
                  color: abaAtiva === 'envio' ? '#ffffff' : '#00205b',
                  fontWeight: 600,
                  border: abaAtiva === 'envio' ? 'none' : '1px solid #dee2e6'
                }}
              >
                <i className="fas fa-file-upload me-2"></i>
                Novo Envio
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${abaAtiva === 'historico' ? 'active' : ''}`}
                onClick={() => setAbaAtiva('historico')}
                style={{
                  backgroundColor: abaAtiva === 'historico' ? '#00205b' : 'transparent',
                  color: abaAtiva === 'historico' ? '#ffffff' : '#00205b',
                  fontWeight: 600,
                  border: abaAtiva === 'historico' ? 'none' : '1px solid #dee2e6'
                }}
              >
                <i className="fas fa-history me-2"></i>
                Histórico de Envios
                {historico.length > 0 && (
                  <span className="badge bg-secondary ms-2">{historico.length}</span>
                )}
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Conteúdo das Abas */}
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              {abaAtiva === 'envio' && renderAbaEnvio()}
              {abaAtiva === 'historico' && renderAbaHistorico()}
            </div>
          </div>
        </div>
      </div>

      {/* Modal de prévia do e-mail antes de enviar */}
      {mostrarConfirmacao && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
              <div className="modal-content">
                <div className="modal-header bg-white">
                  <div>
                    <h5 className="modal-title" style={{ color: '#212529' }}>
                      <i className="fas fa-envelope-open-text me-2" style={{ color: '#00205b' }}></i>
                      Prévia do e-mail
                    </h5>
                    <small style={{ color: '#6c757d' }}>É exatamente assim que vai chegar para a contabilidade. Confirme antes de enviar.</small>
                  </div>
                  <button type="button" className="btn-close" aria-label="Fechar" onClick={() => setMostrarConfirmacao(false)}></button>
                </div>

                <div className="modal-body" style={{ background: '#f0f2f5' }}>
                  <div className="mb-3 p-3 rounded bg-white border">
                    <div className="mb-1">
                      <span className="text-muted" style={{ width: '70px', display: 'inline-block' }}>Para:</span>
                      <strong>{previewDest || '—'}</strong>
                    </div>
                    <div>
                      <span className="text-muted" style={{ width: '70px', display: 'inline-block' }}>Assunto:</span>
                      <strong>{previewAssunto || '—'}</strong>
                    </div>
                  </div>

                  {carregandoPreview ? (
                    <div className="text-center py-5">
                      <div className="spinner-border" style={{ color: '#00205b', width: '3rem', height: '3rem' }}></div>
                      <p className="mt-3 text-muted">Gerando prévia do e-mail...</p>
                    </div>
                  ) : (
                    <iframe
                      title="Prévia do e-mail"
                      srcDoc={previewHtml}
                      style={{ width: '100%', height: '65vh', border: '1px solid #e7e9ee', borderRadius: '8px', background: '#ffffff' }}
                    />
                  )}
                </div>

                <div className="modal-footer bg-white" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '14px' }}>
                  <label
                    htmlFor="confirmaInfosNotas"
                    className="d-flex align-items-center gap-3 w-100 m-0"
                    style={{
                      background: confirmacaoMarcada ? '#e8f5ee' : '#eef2f8',
                      border: `2px solid ${confirmacaoMarcada ? '#1f9d6b' : '#00205b'}`,
                      borderRadius: '10px',
                      padding: '14px 18px',
                      cursor: (carregandoPreview || !previewHtml || carregando) ? 'not-allowed' : 'pointer',
                      transition: 'background-color .2s ease, border-color .2s ease'
                    }}
                  >
                    <input
                      className="form-check-input m-0"
                      type="checkbox"
                      id="confirmaInfosNotas"
                      style={{ width: '22px', height: '22px', flex: 'none', cursor: 'inherit' }}
                      checked={confirmacaoMarcada}
                      disabled={carregandoPreview || !previewHtml || carregando}
                      onChange={(e) => setConfirmacaoMarcada(e.target.checked)}
                    />
                    <span style={{ fontSize: '15px', fontWeight: 600, color: confirmacaoMarcada ? '#1f7a52' : '#00205b' }}>
                      <i className={`fas ${confirmacaoMarcada ? 'fa-check-circle' : 'fa-exclamation-circle'} me-2`}></i>
                      Confirmo que revisei a prévia e as informações estão corretas
                    </span>
                  </label>

                  <div className="d-flex justify-content-end gap-2 w-100">
                    <button type="button" className="btn btn-outline-secondary" onClick={() => setMostrarConfirmacao(false)} disabled={carregando}>
                      <i className="fas fa-pen me-2"></i>Revisar
                    </button>
                    <button
                      type="button"
                      className="btn"
                      style={{ backgroundColor: '#00205b', borderColor: '#00205b', color: '#ffffff', fontWeight: 600 }}
                      onClick={enviarNotas}
                      disabled={carregando || carregandoPreview || !previewHtml || !confirmacaoMarcada}
                    >
                      <i className={`fas ${carregando ? 'fa-spinner fa-spin' : 'fa-check'} me-2`}></i>
                      {carregando ? 'Enviando...' : 'Confirmar e Enviar'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default EnvioNotas_cliente;
